import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-expert',
  templateUrl: './expert.component.html',
  styleUrls: ['./expert.component.scss'],
})
export class ExpertComponent implements OnInit {
  API = this.helper.getApi();
  domain = this.helper.getDomain();
  allTherapists = [];
  availableTherapists = [];
  showFoundResults: boolean;
  showChosenResults: boolean;
  clinicExpert: boolean;
  chosenTherapists = [];
  selectedClinic: any;
  active_step: string;
  flowType: string;
  clinics: string;
  superClinicId: string;
  service: string;
  singleClinic: string;
  haveTherapists: boolean;
  noBodyParts: string;
  currentUser: any = this.helper.getStorage("currentUser");
  allClinicTherapists: any = this.helper.getStorage("allClinicTherapists");
  allClinics: Array<any> = this.helper.getStorage("allClinics");
  allBookings: Array<any> = this.helper.getStorage("bookings");
  headerText: string;
  subHeaderText: string;
  contentText: string;
  readonly steps: any = Constants.STEPS;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private router: Router
  ) {}

  ngOnInit() {
    this.active_step = this.steps.expert;

    this.route.queryParams.subscribe((params: Params) => {
      this.flowType = params.type;
      this.clinics = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.singleClinic = params.singleClinic;
      this.noBodyParts = params.noBodyParts;

      let clinicId = Array.isArray(params.clinics)
        ? params.clinics[0]
        : params.clinics;

      this.selectedClinic = this.allClinics.filter((el) => el.id === clinicId);
      if (this.selectedClinic.length > 0) {
        let headerTextItem = _.find(this.selectedClinic[0].booking_texts, t => t.step === 'step_expert' && t.step_context === 'ctx_general'&& t.text_type === 'header');
        if (headerTextItem && headerTextItem.text) this.headerText = headerTextItem.text;
        
        let subHeaderTextItem = _.find(this.selectedClinic[0].booking_texts, t => t.step === 'step_expert' && t.step_context === 'ctx_general'&& t.text_type === 'subheader');
        if (subHeaderTextItem && subHeaderTextItem.text) this.subHeaderText = subHeaderTextItem.text;

        let contentTextItem = _.find(this.selectedClinic[0].booking_texts, t => t.step === 'step_expert' && t.step_context === 'ctx_general'&& t.text_type === 'content');
        if (contentTextItem && contentTextItem.text) this.contentText = contentTextItem.text;
      }
    });

    this.availableTherapists = this.allClinicTherapists;
  }

  goBack() {
    let params = {
      clinics: this.clinics,
      type: this.flowType,
      service: this.service,
      superClinicId: this.superClinicId,
      singleClinic: this.singleClinic,
    };

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    if (this.noBodyParts === 'true') {
      this.router.navigate(['/offer-fysiq'], navigationExtras);
    } else {
      this.router.navigate(['/body-parts'], navigationExtras);
    }
  }

  navigateToService() {
    let physiotherapists = [];

    if (this.chosenTherapists.length > 0 && this.clinicExpert) {
      physiotherapists = this.chosenTherapists;
      this.clinicExpert = true;

      localStorage.setItem('expertTherapist', JSON.stringify(physiotherapists));
    } else {
      physiotherapists = this.availableTherapists;
      this.clinicExpert = false;

      physiotherapists.sort((a, b) => b.priority - a.priority);
      this.clinicExpert = false;
    }

    physiotherapists = physiotherapists.map((el) => el.id);

    localStorage.setItem('clinicTherapists', JSON.stringify(physiotherapists));

    const params = {
      clinics: this.selectedClinic[0].id,
      preselected_therapist: false,
      isExpert: this.clinicExpert,
      bookings: this.allBookings ? this.allBookings.length : 0,
      type: this.flowType,
      service: this.service,
      singleClinic: this.singleClinic,
      noBodyParts: this.noBodyParts,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    const has_expert_therapists = this.allClinicTherapists.filter(
      (therapist) => therapist.is_expert === 1
    );
     
    // add additional param, when no expert therapists
    if (has_expert_therapists.length === 0) {
      params['noExperts'] = true;
    } else {
      params['noExperts'] = false;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    localStorage.removeItem('selectedService');

    this.router.navigate(['/service'], navigationExtras);

    document.querySelector('.booking-steps').scrollIntoView({
      behavior: 'smooth',
    });
  }

  removeFoundResults() {
    this.showFoundResults = false;
  }

  chooseTherapist(therapist: any) {
    this.showFoundResults = false;
    this.showChosenResults = true;
    this.chosenTherapists = [];

    this.chosenTherapists.push(therapist);
  }

  removeTherapist(id: string) {
    this.chosenTherapists = [];

    this.showFoundResults = true;
    this.showChosenResults = false;
  }

  enableExpert(el) {
    this.clinicExpert = true;

    this.availableTherapists = this.allClinicTherapists.filter(
      (therapist) => therapist.is_expert === 1
    );

    this.availableTherapists = this.availableTherapists.filter(
      (therapist) => therapist.services.some(el => el.treatment_type_id === this.service && el.service_type === "KX")
    );
    
    this.availableTherapists.map((therapist) => {
      if (therapist.picture.includes('person_placeholder.jpg')) {
        therapist.picture = this.domain + "assets/icons/placeholder.svg";
      }
    });

    if (this.chosenTherapists.length === 0) {
      this.showFoundResults = true;
    }
  }

  disableExpert(el) {
    this.clinicExpert = false;
   
    this.availableTherapists = this.allClinicTherapists;

    this.navigateToService();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/expert/expert.component.ts